import React from "react";
import style from "./PreviewPostLink.module.css";

const expDomain = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/g;
const regexDomain = new RegExp(expDomain);

const handleOpenDivLink = (url: string) => {
  window.open(url, "_blank");
  return;
};

const PreviewPostLink = (props: any) => {
  const { graphDetail, url } = props;
  const domain =
    url?.match(regexDomain)?.[0] || graphDetail?.title?.match(regexDomain)?.[0];
  return (
    <div
      className={style.previewPostContainer}
      // style={{ height: graphDetail.images ? "" : 82 }}
      onClick={() => {
        handleOpenDivLink(graphDetail?.url ? graphDetail?.url : url);
      }}
    >
      {graphDetail?.videos?.length > 0 ? (
        <>
          <div
            className={style.videoCover}
            style={{ backgroundImage: `url(${graphDetail.images[0].url})` }}
          />
          {/* <img
            className={style.videoCover}
            src={graphDetail.images[0].url}
            alt=""
          /> */}

          <div className={style.desBox}>
            <div className={style.detailText}>{domain}</div>
            {(graphDetail.title && graphDetail.title !== "div") && (
              <div className={style.title}><>{graphDetail.title}</></div>
            )}
            <div className={style.detailText}>{graphDetail?.description}</div>
          </div>
        </>
      ) : (
        <>
          {graphDetail.images && (
            <div
              className={style.videoCover}
              style={{
                backgroundImage: `url(${
                  graphDetail?.images ? graphDetail.images[0].url : ""
                })`,
              }}
            />
          )}

          <div className={style.desBox}>
            <div className={style.detailText}>{domain}</div>
            {(graphDetail.title && graphDetail.title !== "div") && (
              <div className={style.title}><>{graphDetail.title}</></div>
            )}
            <div className={style.detailText}>{graphDetail?.description}</div>
          </div>
        </>
      )}
    </div>
  );
};

export default PreviewPostLink;
